var _path, _path2, _path3, _path4, _g, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckEmailAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 150,
    height: 150,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.107 121h22.786L90 141H61l3.107-20Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 29,
    height: 20,
    x: 61,
    y: 121,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.107 121h22.786L90 141H61l3.107-20Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M63 121h25v4H63z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 67.7C25 61.79 29.79 57 35.7 57h79.18c5.909 0 10.7 4.79 10.7 10.7v42.8c0 5.909-4.791 10.7-10.7 10.7H35.7c-5.91 0-10.7-4.791-10.7-10.7V67.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 116,
    r: 3,
    fill: "#1485FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M32.509 71.196c0-4.22 4.095-7.642 9.147-7.642h67.688c5.052 0 9.147 3.421 9.147 7.642v30.572c0 4.221-4.095 7.643-9.147 7.643H41.656c-5.052 0-9.147-3.422-9.147-7.643V71.196Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M33.009 71.196c0-3.864 3.783-7.142 8.647-7.142h67.688c4.864 0 8.647 3.278 8.647 7.142v30.572c0 3.864-3.783 7.143-8.647 7.143H41.656c-4.864 0-8.647-3.279-8.647-7.143V71.196Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M51 145.5c0-2.485 1.908-4.5 4.26-4.5h40.48c2.352 0 4.26 2.015 4.26 4.5s-1.908 4.5-4.26 4.5H55.26c-2.352 0-4.26-2.015-4.26-4.5Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1485FD",
    fillRule: "evenodd",
    d: "m74.785 45.084-1.023-.9L32.581 7.95c-1.376-1.21-.097-3.435 1.64-2.856L78.2 19.754l.013.005c.075.03.157.054.266.086l.192.057c.191.06.428.14.65.268.225.13.455.32.61.607.157.29.212.63.169 1.015l-2.536 22.22c-.153 1.35-1.76 1.968-2.779 1.072Zm3.236-24.84c.097.04.214.073.338.11.29.085.623.183.87.384-.247-.2-.58-.299-.87-.384a4.045 4.045 0 0 1-.338-.11Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "m76.131 43.764 2.535-22.22a.29.29 0 0 0-.196-.308L33.73 6.323c-.299-.1-.52.284-.282.492L75.652 43.95a.29.29 0 0 0 .48-.184Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE9FC",
    d: "m71.128 26.251-12.815 2.316 17.292 15.13-4.477-17.446Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1485FD",
    fillRule: "evenodd",
    d: "m76.29 43.482-3.624-17.684-1.702.348 3.625 17.685 1.495.795.207-1.144Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.941 6.216 65.507 14.432c.155.035.15.256-.005.284l-21.72 3.922a.145.145 0 0 1-.081-.009L33.854 6.491c-.163-.068-.085-.313.087-.275Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1485FD",
    fillRule: "evenodd",
    d: "M34.084 5.814Zm7.395 3.1 54.148 11.93-17.953 3.241-36.195-15.17Zm36.392 15.254Zm21.283-2.547.157-.707-.156.707h-.001ZM34.022 5.492l-.187.848v.001m.187-.849c-1.206-.266-1.749 1.447-.61 1.925L77.2 25.77c.18.076.379.098.572.063l21.719-3.922c1.09-.197 1.119-1.748.038-1.987L34.022 5.492m0 0-.187.848.187-.848Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.407 29.776 23.065-3.327a.29.29 0 0 0 .092-.544L33.949 6.368c-.263-.137-.537.163-.378.412l14.55 22.864a.29.29 0 0 0 .286.132Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1485FD",
    fillRule: "evenodd",
    d: "M33.977 6.143c-1.051-.545-2.147.651-1.511 1.65l14.922 22.318c.245.384.692.59 1.143.524l23.065-3.326c1.114-.161 1.367-1.656.368-2.175L33.977 6.144Zm1.111 2.536 34.477 17.167-20.912 3.016L35.088 8.68ZM93.348 27.617a1 1 0 0 1 1.068-.927c.882.063 1.868.146 2.93.257a1 1 0 1 1-.207 1.989 86.942 86.942 0 0 0-2.864-.25 1 1 0 0 1-.927-1.07Zm3.132 55.242a1 1 0 0 1 .325-1.376c.693-.428 1.388-.95 2.004-1.578a1 1 0 1 1 1.428 1.4 12.624 12.624 0 0 1-2.38 1.88 1 1 0 0 1-1.377-.326Zm2.758-22.237c-.487.553-.733 1.16-.718 1.904a1 1 0 1 1-2 .04c-.026-1.29.43-2.373 1.217-3.266a1 1 0 1 1 1.501 1.322Zm-1.392 3.751a1 1 0 0 1 1.341.448c.178.355.395.734.654 1.138.271.422.523.836.755 1.242a1 1 0 0 1-1.736.993 26.25 26.25 0 0 0-.701-1.153 14.183 14.183 0 0 1-.76-1.326 1 1 0 0 1 .447-1.342Zm1.295-36.219a1 1 0 0 1 1.129-.852c.941.131 1.915.284 2.91.462a.999.999 0 1 1-.352 1.969 74.858 74.858 0 0 0-2.834-.45 1 1 0 0 1-.853-1.129Zm.736 30.604a1 1 0 0 1 .438-1.344c.834-.424 1.769-.795 2.758-1.133a1 1 0 1 1 .646 1.893c-.937.32-1.776.656-2.497 1.022a1 1 0 0 1-1.345-.438Zm.706 10.52a1 1 0 0 1 1.302.551c.409 1.01.691 1.967.861 2.873a1 1 0 0 1-1.966.368 13.064 13.064 0 0 0-.749-2.49 1 1 0 0 1 .552-1.302Zm.122 9.962a1 1 0 0 1-.461-1.337 6.867 6.867 0 0 0 .661-2.338 1 1 0 1 1 1.99.203 8.905 8.905 0 0 1-.853 3.011 1 1 0 0 1-1.337.46Zm4.175-50.137a1 1 0 0 1 1.195-.757c.955.215 1.916.455 2.872.723a1 1 0 1 1-.54 1.925 54.383 54.383 0 0 0-2.771-.697 1 1 0 0 1-.756-1.195Zm.267 27.565a1 1 0 0 1 .693-1.233c.798-.223 1.621-.443 2.448-.664l.306-.081a1 1 0 1 1 .516 1.932l-.306.082c-.829.221-1.639.437-2.424.657a1 1 0 0 1-1.233-.693Zm5.36-26.096a1 1 0 0 1 1.275-.612c.946.332 1.876.697 2.778 1.098a1 1 0 1 1-.813 1.828 35.026 35.026 0 0 0-2.628-1.04 1 1 0 0 1-.612-1.274Zm.123 24.609a1 1 0 0 1 .686-1.236c.906-.26 1.799-.53 2.667-.825a1 1 0 0 1 .641 1.895c-.907.307-1.833.588-2.758.852a1 1 0 0 1-1.236-.686Zm5.252-22.395a1 1 0 0 1 1.366-.364 21.37 21.37 0 0 1 2.528 1.702 1 1 0 1 1-1.237 1.571 19.44 19.44 0 0 0-2.293-1.542 1 1 0 0 1-.364-1.367Zm.156 20.667a1 1 0 0 1 .514-1.317c.86-.378 1.661-.789 2.387-1.244a1 1 0 1 1 1.062 1.695 20.45 20.45 0 0 1-2.646 1.38 1 1 0 0 1-1.317-.514Zm4.573-17.304a1 1 0 0 1 1.41.105 12.76 12.76 0 0 1 1.754 2.61 1 1 0 1 1-1.788.897 10.79 10.79 0 0 0-1.481-2.201 1 1 0 0 1 .105-1.41Zm.381 14.547a1 1 0 0 1-.02-1.414 7.235 7.235 0 0 0 1.415-2.037 1 1 0 0 1 1.819.832 9.238 9.238 0 0 1-1.8 2.6 1 1 0 0 1-1.414.02Zm2.634-9.62a1 1 0 0 1 1.172.79c.099.51.166 1.033.2 1.572.034.539.03 1.059-.009 1.56a1 1 0 0 1-1.994-.157c.032-.403.035-.828.007-1.279a10.181 10.181 0 0 0-.167-1.313 1 1 0 0 1 .791-1.173Z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1485FD",
    d: "M90.188 74H41.812C40.26 74 39 75.007 39 76.25v13.5c0 1.243 1.26 2.25 2.813 2.25h48.374C91.742 92 93 90.993 93 89.75v-13.5c0-1.243-1.26-2.25-2.813-2.25Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M56.02 78.927H44.376a1.344 1.344 0 1 0 0 2.688h11.646a1.344 1.344 0 1 0 0-2.688Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.083 84.75H44.375a1.344 1.344 0 1 0 0 2.688h19.708a1.344 1.344 0 1 0 0-2.688Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 75,
    x2: 75,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 75,
    x2: 75,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 66,
    height: 30,
    x: 33,
    y: 65,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_6973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_6973",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmailAddress);
export default __webpack_public_path__ + "static/media/check-email-address.e59a884f5c5fd43b9947c0dab52b7309.svg";
export { ForwardRef as ReactComponent };